// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__rWVtB","imageUploader":"EGiftCard_imageUploader__ztwdh"};